import { DayOfWeekValue, DayOfWeekValues } from 'app/modules/settings/domain/valueObject/DayOfWeek';
import { ApiDayOfWeek } from 'app/modules/settings/infrastructure/dto/ApiDayOfWeek';

export class DayOfWeekMapper {

    static toDomain(apiDay: ApiDayOfWeek): DayOfWeekValue {
        const mapping: Record<ApiDayOfWeek, DayOfWeekValue> = {
            0: DayOfWeekValues.SUNDAY,
            1: DayOfWeekValues.MONDAY,
            2: DayOfWeekValues.TUESDAY,
            3: DayOfWeekValues.WEDNESDAY,
            4: DayOfWeekValues.THURSDAY,
            5: DayOfWeekValues.FRIDAY,
            6: DayOfWeekValues.SATURDAY,
        };

        const domainValue = mapping[apiDay];

        if (domainValue === undefined) {
            throw new Error(`Invalid ApiDayOfWeek value: ${apiDay}`);
        }

        return domainValue;
    }

}
